export default __webpack_public_path__ + "static/media/Rubik-BlackItalic.c674221e.woff2";